// constants
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
// log
import { fetchData } from "../data/dataActions";


const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider, // required
    options: {
      rpc: {
        // 97: "https://data-seed-prebsc-1-s1.binance.org:8545/"
        56: "https://bsc-dataseed1.defibit.io/"
      }
    }
  }
};

const connectRequest = () => {
  return {
    type: "CONNECTION_REQUEST",
  };
};

const connectSuccess = (payload) => {
  return {
    type: "CONNECTION_SUCCESS",
    payload: payload,
  };
};

const connectFailed = (payload) => {
  return {
    type: "CONNECTION_FAILED",
    payload: payload,
  };
};

const updateAccountRequest = (payload) => {
  return {
    type: "UPDATE_ACCOUNT",
    payload: payload,
  };
};

export const connect = () => {
  return async (dispatch) => {
    dispatch(connectRequest());
    const abiResponse = await fetch("/config/abi.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const abi = await abiResponse.json();
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const CONFIG = await configResponse.json();
    const web3Modal = new Web3Modal({
      network: "ma net", // optional
      cacheProvider: false,
      providerOptions // required
    });
    const provider = await web3Modal.connect();
    web3Modal.clearCachedProvider();
    if (provider) {
      Web3EthContract.setProvider(provider);
      let web3 = new Web3(provider);
      try {
      const accounts = await web3.eth.getAccounts();
      
      const networkId = await web3.eth.net.getId();
        if (networkId == CONFIG.NETWORK.ID) {
          const SmartContractObj = new Web3EthContract(
            abi,
            CONFIG.CONTRACT_ADDRESS
          );
            const FZTOKEN = new Web3EthContract(
              abi,
              CONFIG.TOKEN
            );
          dispatch(
            connectSuccess({
              account: accounts[0],
              smartContract: SmartContractObj,
              smartToken: FZTOKEN ,
              web3: web3,
            })
          );


          // Add listeners start
          provider.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          provider.on("chainChanged", () => {
            window.location.reload();
          });

          // Add listeners end
        }
         else {
          dispatch(connectFailed(`Change network to ${CONFIG.NETWORK.NAME}.`));
        }

      }
      
      
      catch (err) {
        dispatch(connectFailed("Something went wrong."));
        console.log(err)
      }
    } else {
      dispatch(connectFailed("Install Metamask."));
    } 
  };
};

export const updateAccount = (account) => {
  return async (dispatch) => {
    dispatch(updateAccountRequest({ account: account }));
    dispatch(fetchData(account));
  };
};
